import URI from 'urijs'

export function getQuery (query, uri = window.location) {
  uri = uri ?? window.location
  try {
    const params = URI.parseQuery(URI(uri).query())

    if (params[query]) {
      if (Array.isArray(params[query])) {
        return params[query]
      } else {
        return [params[query]]
      }
    } else {
      return null
    }
  } catch (error) {
    return null
  }
}
